import { MatchMode } from '../types/types';

export const processFilterMatchMode = (matchMode: MatchMode, value: string) => {
  let newMatchMode: MatchMode;
  switch (matchMode) {
    case 'datetime-equals':
      newMatchMode = value.includes('T') ? 'equals' : 'dateIs';
      return { [newMatchMode]: value };
    case 'datetime-between':
      newMatchMode = value.includes('T') ? 'between' : 'dateBetween';
      return { [newMatchMode]: value };
    case 'datetime-notEquals':
      newMatchMode = value.includes('T') ? 'notEquals' : 'dateIsNot';
      return { [newMatchMode]: value };
    case 'isEmpty':
      return { isEmpty: true };
    case 'isNotEmpty':
      return { isEmpty: false };
    // isNull needs no case: its boolean sentinel already serializes as isNull=true, and raw server filters keep their own isNull value
    case 'isNotNull':
      return { isNull: false };
    default:
      return { [matchMode]: value };
  }
};
